const countEmptyRows = (rowsPerPage: number, itemsCount: number, page: number) =>
  rowsPerPage - Math.min(rowsPerPage, itemsCount - page * rowsPerPage)

export { countEmptyRows }
